import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { RefreshCw } from 'lucide-react';
import { BUILD_ID } from '../buildInfo';
import { isPlatformPath } from '../utils/platformPaths';

const CHECK_INTERVAL_MS = 3 * 60 * 1000;

export const UpdateBanner = () => {
  const location = useLocation();
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      try {
        const res = await fetch(`/version.json?ts=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return;
        const data = await res.json();
        if (!cancelled && data.version && data.version !== BUILD_ID) {
          setUpdateAvailable(true);
        }
      } catch {
        /* network hiccup — try again next cycle */
      }
    };
    check();
    const iv = setInterval(check, CHECK_INTERVAL_MS);
    const onFocus = () => check();
    window.addEventListener('focus', onFocus);
    return () => {
      cancelled = true;
      clearInterval(iv);
      window.removeEventListener('focus', onFocus);
    };
  }, []);

  if (!updateAvailable || !isPlatformPath(location.pathname)) return null;

  return (
    <div
      data-testid="update-banner"
      className="fixed top-3 left-1/2 -translate-x-1/2 z-[9999] flex items-center gap-3 bg-teal-500 text-black text-sm font-medium py-2 pl-4 pr-2 rounded-full shadow-2xl"
    >
      <span className="whitespace-nowrap">A new version is available — Refresh to update</span>
      <button
        data-testid="update-banner-refresh-btn"
        onClick={() => window.location.reload()}
        className="flex items-center gap-1.5 bg-black/80 text-white px-3 py-1 rounded-full text-xs font-semibold hover:bg-black transition-colors"
      >
        <RefreshCw size={12} /> Refresh
      </button>
    </div>
  );
};

export default UpdateBanner;
